import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import { ReactComponent as TryangleWarning } from '../../../../../assets/images/icon/tryangle-warning.svg';
import { isIOS } from "react-device-detect";
import { deepLinkBridgeElseNewTab } from "../../../../../utils";
const ProgramBookDeadlineExpire = () => {
    const navigate = useNavigate();

    return <>
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            textAlign: 'center'
        }}>
            <div>
                <div>
                    <TryangleWarning width={100} height={100} fill="var(--secondarys400)" />
                </div>
                <div className="sub-title/st5 base/black" style={{ marginTop: 10 }}>
                    결제 기한이 만료되었습니다
                </div>
                <div className="body/b3 secondary/s700">
                    기한 내 결제가 완료되지 않아<br />
                    예약이 자동 취소되었습니다.
                </div>
            </div>
        </div>
        <div style={{ margin: 20, paddingTop: '20px', position: 'absolute', bottom: '0px', width: 'calc(100% - 40px)', maxWidth: '440px', marginBottom: isIOS ? 46 : 20 }}>
            <Button className="sub-title/st3 base/white" color="default" variant="solid" style={{ width: '100%', height: '50px' }} onClick={() => navigate('/explore')}>프로그램 둘러보기</Button>
            <Button className="sub-title/st2 secondary/s600" color="default" variant="outlined" style={{ width: '100%', height: '50px', marginTop: 10, border: 'none' }} onClick={() => deepLinkBridgeElseNewTab('https://pf.kakao.com/_xmWxbYG/chat')}>컨시어지 문의하기</Button>
        </div>
    </>
}

export default ProgramBookDeadlineExpire;